<template>
    <CommonTemplate
        class="loan-application"
        :class="{
            'loan-application_no-timer': !isSbg
        }"
    >
        <template v-slot:top>
            <div class="loan-application__top">
                <Progress/>
            </div>
        </template>
        <div class="loan-application__main">
            <div
                v-if="showCalc"
                class="loan-application__calc"
            >
                <div class="loan-application__calc-top">
                    <p class="loan-application__calc-info">
                        {{ sum | price }} ₽
                        <span v-if="isSbg">на {{ days.count }} {{ daysType }}</span>
                    </p>
                    <p v-if="!isSbg">
                        <b>Сумма страхования:</b>
                    </p>
                </div>
                <Sum
                    v-model="sum"
                    :showRangeInfo="3"
                />
                <Days
                    v-if="isSbg"
                    v-model="days"
                />
            </div>
            <h1
                v-if="title"
                class="loan-application__title"
            >
                {{ title }}
            </h1>
            <div
                class="loan-application__content"
            >
                <div
                    v-if="showTimer"
                    class="loan-application__timer"
                >
                    <p class="loan-application__timer-desc">
                        Займ под 0%<br/>
                        закончится через
                    </p>
                    <Timer
                        class="loan-application__timer-el"
                        defaultColor="#bbd0d6"
                        activeColor="#08ba89"
                        :time="20 * 60"
                        :past="past"
                    />
                </div>
                <div class="loan-application__form">
                    <router-view/>
                </div>
            </div>
        </div>
    </CommonTemplate>
</template>

<script>
import './loan-application.scss'
import Storage from '@/ext/storage/Storage'

import price from '@/helpers/string/price'
import term from '@/helpers/string/term'

import sbg from '@/mixins/sbg'

export default {
    name: 'LoanApplication',
    mixins: [
        sbg,
    ],
    data() {
        return {
            past: 0,
            days: {
                type: 'days',
                count: 10
            },
            sum: 10000
        }
    },
    created() {
        const name = 'loan-application-timer'
        const timer = Storage.get(name)

        if (!timer) {
            Storage.set(name, +new Date())
            return
        }

        const past = +new Date() - timer

        if (timer < +new Date() - 8 * 60 * 60 * 1000) {
            Storage.set(name, +new Date())
        } else {
            this.past = past / 1000
        }
    },
    computed: {
        title() {
            return this.$route.meta?.title
        },
        showCalc() {
            return !!this.$route.meta?.showCalc
        },
        showTimer() {
            return this.isSbg && this.$route.name !== 'LoanCard'
        },
        daysType() {
            if (this.days.type === 'days') {
                return term(this.days.count)
            }

            return 'недель'
        }
    },
    components: {
        Progress: () => import('@/applications/loan-application/components/progress/Progress'),
        Timer: () => import('@/components/common/timer/Timer'),
        Days: () => import('@/components/calculators/days/Days'),
        Sum: () => import('@/components/calculators/sum/Sum'),
    },
    filters: {
        price
    }
}
</script>